const Tokens = () => import(/* webpackChunkName: "tokens" */ '@/views/tokens/Index');
const TokenList = () => import(/* webpackChunkName: "tokens" */ '@/views/tokens/List');
const TokenNew = () => import(/* webpackChunkName: "tokens" */ '@/views/tokens/New');

export default {
  path: '/tokens',
  component: Tokens,
  children: [
    {
      path: '',
      name: 'TokenList',
      component: TokenList
    },
    {
      path: 'new',
      name: 'TokenNew',
      component: TokenNew
    },
    {
      path: ':jti',
      name: 'TokenDetail',
      component: TokenList,
      props: true
    }
  ]
};
